import { OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.PRIMARY_BROWSER_TAB_LOCK)
export default class PrimaryBrowserTabLock extends BaseModel {
  @StringField()
  public id: string

  @StringField()
  public tabId: string
}
